var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSonorousLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 387.38 189.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.72;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}.cls-17{fill:url(#linear-gradient-16);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:url(#linear-gradient-18);}.cls-20{fill:url(#linear-gradient-19);}.cls-21{fill:url(#linear-gradient-20);}.cls-22{fill:url(#linear-gradient-21);}.cls-23{fill:url(#linear-gradient-22);}.cls-24{fill:url(#linear-gradient-23);}.cls-25{fill:url(#linear-gradient-24);}.cls-26{fill:url(#linear-gradient-25);}.cls-27{fill:url(#linear-gradient-26);}.cls-28{fill:url(#linear-gradient-27);}.cls-29{fill:url(#linear-gradient-28);}.cls-30{fill:url(#linear-gradient-29);}.cls-31{fill:url(#linear-gradient-30);}.cls-32{fill:url(#linear-gradient-31);}.cls-33{fill:url(#linear-gradient-32);}.cls-34{fill:url(#linear-gradient-33);}.cls-35{fill:url(#linear-gradient-34);}.cls-36{fill:url(#linear-gradient-35);}.cls-37{fill:url(#linear-gradient-36);}.cls-38{opacity:0.65;}.cls-39{fill:url(#linear-gradient-37);}.cls-40{fill:url(#linear-gradient-38);}.cls-41{fill:url(#linear-gradient-39);}.cls-42{fill:url(#linear-gradient-40);}.cls-43{fill:url(#linear-gradient-41);}.cls-44{fill:url(#linear-gradient-42);}.cls-45{fill:url(#linear-gradient-43);}.cls-46{fill:url(#linear-gradient-44);}.cls-47{fill:url(#linear-gradient-45);}.cls-48{fill:url(#linear-gradient-46);}.cls-49{fill:url(#linear-gradient-47);}.cls-50{fill:url(#linear-gradient-48);}.cls-51{fill:url(#linear-gradient-49);}.cls-52{fill:url(#linear-gradient-50);}.cls-53{fill:url(#linear-gradient-51);}.cls-54{fill:url(#linear-gradient-52);}.cls-55{fill:url(#linear-gradient-53);}.cls-56{fill:url(#linear-gradient-54);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 93.89,
    y1: 143.16,
    x2: 93.89,
    y2: 29.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02cae6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 115.81,
    y1: 172.63,
    x2: 115.81,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 204.63,
    y1: 113.26,
    x2: 204.63,
    y2: 59.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 226.95,
    y1: 129.26,
    x2: 226.95,
    y2: 43.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 249.26,
    y1: 106.11,
    x2: 249.26,
    y2: 66.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 293.47,
    y1: 101.89,
    x2: 293.47,
    y2: 70.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 138.11,
    y1: 146.11,
    x2: 138.11,
    y2: 26.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 160.42,
    y1: 129.26,
    x2: 160.42,
    y2: 43.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 182.74,
    y1: 143.16,
    x2: 182.74,
    y2: 29.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 71.58,
    y1: 117.47,
    x2: 71.58,
    y2: 55.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 271.58,
    y1: 97.26,
    x2: 271.58,
    y2: 75.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 338.11,
    y1: 105.68,
    x2: 338.11,
    y2: 67.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 360,
    y1: 98.11,
    x2: 360,
    y2: 74.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 382.32,
    y1: 91.37,
    x2: 382.32,
    y2: 81.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 5.05,
    y1: 94.74,
    x2: 5.05,
    y2: 77.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 49.26,
    y1: 99.37,
    x2: 49.26,
    y2: 73.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 27.37,
    y1: 106.11,
    x2: 27.37,
    y2: 66.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 315.79,
    y1: 94.74,
    x2: 315.79,
    y2: 77.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 93.89,
    y1: 160.03,
    x2: 93.89,
    y2: 46.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5363d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02cae6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 115.81,
    y1: 189.51,
    x2: 115.81,
    y2: 16.87,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 204.63,
    y1: 130.14,
    x2: 204.63,
    y2: 76.24,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 226.95,
    y1: 146.14,
    x2: 226.95,
    y2: 60.24,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 249.26,
    y1: 122.98,
    x2: 249.26,
    y2: 83.82,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 293.47,
    y1: 118.77,
    x2: 293.47,
    y2: 87.61,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 138.11,
    y1: 162.98,
    x2: 138.11,
    y2: 43.4,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 160.42,
    y1: 146.14,
    x2: 160.42,
    y2: 60.24,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 182.74,
    y1: 160.03,
    x2: 182.74,
    y2: 46.35,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 71.58,
    y1: 134.35,
    x2: 71.58,
    y2: 72.03,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 271.58,
    y1: 114.14,
    x2: 271.58,
    y2: 92.66,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 338.11,
    y1: 122.56,
    x2: 338.11,
    y2: 84.24,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 360,
    y1: 114.98,
    x2: 360,
    y2: 90.98,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 382.32,
    y1: 108.24,
    x2: 382.32,
    y2: 98.14,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 5.05,
    y1: 111.61,
    x2: 5.05,
    y2: 94.77,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 49.26,
    y1: 116.24,
    x2: 49.26,
    y2: 90.56,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 27.37,
    y1: 122.98,
    x2: 27.37,
    y2: 83.82,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 315.79,
    y1: 111.61,
    x2: 315.79,
    y2: 94.35,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 292.19,
    y1: 152.79,
    x2: 292.19,
    y2: 39.11,
    gradientTransform: "translate(1.65 -1.09) rotate(0.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5363d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e592"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 270.27,
    y1: 182.26,
    x2: 270.27,
    y2: 9.63,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 181.45,
    y1: 122.9,
    x2: 181.45,
    y2: 69,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 159.14,
    y1: 138.9,
    x2: 159.14,
    y2: 53,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 136.82,
    y1: 115.74,
    x2: 136.82,
    y2: 76.58,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 92.61,
    y1: 111.53,
    x2: 92.61,
    y2: 80.37,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 247.98,
    y1: 155.74,
    x2: 247.98,
    y2: 36.16,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 225.66,
    y1: 138.9,
    x2: 225.66,
    y2: 53,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 203.35,
    y1: 152.79,
    x2: 203.35,
    y2: 39.11,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 314.51,
    y1: 127.11,
    x2: 314.51,
    y2: 64.79,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 114.51,
    y1: 106.9,
    x2: 114.51,
    y2: 85.42,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 47.98,
    y1: 115.32,
    x2: 47.98,
    y2: 77,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 26.09,
    y1: 107.74,
    x2: 26.09,
    y2: 83.74,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 3.77,
    y1: 101,
    x2: 3.77,
    y2: 90.9,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 381.03,
    y1: 104.37,
    x2: 381.03,
    y2: 87.53,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 336.82,
    y1: 109,
    x2: 336.82,
    y2: 83.32,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 358.72,
    y1: 115.74,
    x2: 358.72,
    y2: 76.58,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 70.3,
    y1: 104.37,
    x2: 70.3,
    y2: 87.11,
    xlinkHref: "#linear-gradient-37"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sonorous_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.89,143.16a4.87,4.87,0,0,1-5-5V34.53a5.06,5.06,0,1,1,10.11,0V137.68A5.52,5.52,0,0,1,93.89,143.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.79,172.63a4.86,4.86,0,0,1-5.05-5V5.05a5.05,5.05,0,1,1,10.1,0V167.16A5,5,0,0,1,115.79,172.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.63,113.26a4.86,4.86,0,0,1-5-5.05V64.42a5,5,0,0,1,10.1,0v44.21A4.77,4.77,0,0,1,204.63,113.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M227,129.26a4.87,4.87,0,0,1-5.06-5V48.42a5.06,5.06,0,0,1,10.11,0v75.79A4.86,4.86,0,0,1,227,129.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.26,106.11a4.87,4.87,0,0,1-5-5.06V72a5.06,5.06,0,0,1,10.11,0v29.05A5.44,5.44,0,0,1,249.26,106.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M293.47,101.89a4.86,4.86,0,0,1-5.05-5v-21a5.06,5.06,0,0,1,10.11,0v21A5.12,5.12,0,0,1,293.47,101.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.11,146.11a4.87,4.87,0,0,1-5.06-5.06V31.58a5.06,5.06,0,0,1,10.11,0V141.05A4.87,4.87,0,0,1,138.11,146.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M160.42,129.26a4.86,4.86,0,0,1-5-5V48.42a5,5,0,0,1,10.1,0v75.79A4.86,4.86,0,0,1,160.42,129.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M182.74,143.16a4.87,4.87,0,0,1-5.06-5V34.53a5.06,5.06,0,1,1,10.11,0V137.68C187.79,140.63,185.26,143.16,182.74,143.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.58,117.47a4.86,4.86,0,0,1-5-5V60.21a5,5,0,1,1,10.1,0v52.63A4.77,4.77,0,0,1,71.58,117.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M271.58,97.26a4.86,4.86,0,0,1-5.05-5.05V80.84a5.05,5.05,0,0,1,10.1,0V92.21A5.42,5.42,0,0,1,271.58,97.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M338.11,105.68a4.87,4.87,0,0,1-5.06-5.05V72.42a5.06,5.06,0,0,1,10.11,0v28.21A5.43,5.43,0,0,1,338.11,105.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M360,98.11A4.87,4.87,0,0,1,355,93.05V79.16a5.05,5.05,0,1,1,10.1,0V93.05A4.87,4.87,0,0,1,360,98.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M382.32,91.37a4.87,4.87,0,0,1-5.06-5.05h0a5.06,5.06,0,1,1,5.06,5.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M5.05,94.74a4.87,4.87,0,0,1-5-5.06V83a4.87,4.87,0,0,1,5.05-5.06A4.87,4.87,0,0,1,10.11,83v6.73A4.87,4.87,0,0,1,5.05,94.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M49.26,99.37a4.87,4.87,0,0,1-5-5.05V78.74a5.06,5.06,0,1,1,10.11,0V94.32A5.13,5.13,0,0,1,49.26,99.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M27.37,106.11a4.87,4.87,0,0,1-5.05-5.06V72a4.86,4.86,0,0,1,5.05-5,4.86,4.86,0,0,1,5.05,5v29.05A5.44,5.44,0,0,1,27.37,106.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M315.79,94.74a4.87,4.87,0,0,1-5.05-5.06V82.53a5.05,5.05,0,1,1,10.1,0v7.15A4.87,4.87,0,0,1,315.79,94.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M93.89,160a4.86,4.86,0,0,1-5-5.05V51.4A5.06,5.06,0,0,1,99,51.4V154.56A5.51,5.51,0,0,1,93.89,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M115.79,189.51a4.87,4.87,0,0,1-5.05-5.06V21.93a5.05,5.05,0,1,1,10.1,0V184A5,5,0,0,1,115.79,189.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M204.63,130.14a4.87,4.87,0,0,1-5-5.06V81.3a5.05,5.05,0,1,1,10.1,0v44.21A4.78,4.78,0,0,1,204.63,130.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M227,146.14a4.87,4.87,0,0,1-5.06-5.06V65.3a5.06,5.06,0,1,1,10.11,0v75.78A4.87,4.87,0,0,1,227,146.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M249.26,123a4.87,4.87,0,0,1-5-5V88.87a5.06,5.06,0,0,1,10.11,0v29.06A5.44,5.44,0,0,1,249.26,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M293.47,118.77a4.87,4.87,0,0,1-5.05-5V92.66a5.06,5.06,0,0,1,10.11,0v21.06A5.13,5.13,0,0,1,293.47,118.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M138.11,163a4.87,4.87,0,0,1-5.06-5V48.45a5.06,5.06,0,0,1,10.11,0V157.93A4.87,4.87,0,0,1,138.11,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M160.42,146.14a4.87,4.87,0,0,1-5-5.06V65.3a5.05,5.05,0,1,1,10.1,0v75.78A4.87,4.87,0,0,1,160.42,146.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M182.74,160a4.87,4.87,0,0,1-5.06-5.05V51.4a5.06,5.06,0,0,1,10.11,0V154.56A5.51,5.51,0,0,1,182.74,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M71.58,134.35a4.86,4.86,0,0,1-5-5V77.08a5,5,0,0,1,10.1,0v52.64A4.78,4.78,0,0,1,71.58,134.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M271.58,114.14a4.87,4.87,0,0,1-5.05-5.06V97.72a5.05,5.05,0,1,1,10.1,0v11.36A5.43,5.43,0,0,1,271.58,114.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M338.11,122.56a4.87,4.87,0,0,1-5.06-5V89.3a5.06,5.06,0,1,1,10.11,0v28.21A5.44,5.44,0,0,1,338.11,122.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M360,115a4.86,4.86,0,0,1-5.05-5V96a5.05,5.05,0,1,1,10.1,0v13.9A4.86,4.86,0,0,1,360,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M382.32,108.24a4.87,4.87,0,0,1-5.06-5h0a5.06,5.06,0,1,1,5.06,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M5.05,111.61a4.86,4.86,0,0,1-5-5V99.82a4.86,4.86,0,0,1,5.05-5,4.87,4.87,0,0,1,5.06,5v6.74A4.87,4.87,0,0,1,5.05,111.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M49.26,116.24a4.86,4.86,0,0,1-5-5V95.61a5.06,5.06,0,0,1,10.11,0v15.58A5.12,5.12,0,0,1,49.26,116.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M27.37,123a4.86,4.86,0,0,1-5.05-5V88.87a4.86,4.86,0,0,1,5.05-5.05,4.86,4.86,0,0,1,5.05,5.05v29.06A5.44,5.44,0,0,1,27.37,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M315.79,111.61a4.86,4.86,0,0,1-5.05-5V99.4a5,5,0,1,1,10.1,0v7.16A4.86,4.86,0,0,1,315.79,111.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M288.23,147.31l.39-103.15a5.05,5.05,0,1,1,10.1,0l-.39,103.58a4.85,4.85,0,0,1-5.07,5C290.73,152.8,288.22,150.26,288.23,147.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M266.22,176.7l.61-162.1a5.06,5.06,0,0,1,10.11,0l-.62,162.52a4.87,4.87,0,0,1-5.07,5A5,5,0,0,1,266.22,176.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M177.6,117.84l.17-44.21a5.05,5.05,0,0,1,10.1,0l-.16,43.79a4.86,4.86,0,0,1-5.07,5A4.78,4.78,0,0,1,177.6,117.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M155.23,133.34l.28-75.79a5.06,5.06,0,1,1,10.11,0l-.29,75.78a5.05,5.05,0,1,1-10.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M133,110.09l.11-29a5.05,5.05,0,0,1,10.1,0l-.11,29.05a4.87,4.87,0,0,1-5.07,5A5.43,5.43,0,0,1,133,110.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M88.8,105.72l.08-21.06A5.06,5.06,0,0,1,99,84.7l-.08,21.06a4.87,4.87,0,0,1-5.07,5A5.13,5.13,0,0,1,88.8,105.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M244,150.51,244.42,41a5.05,5.05,0,1,1,10.1,0l-.41,109.47a5.06,5.06,0,1,1-10.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M221.75,133.59,222,57.8a5.05,5.05,0,1,1,10.1,0l-.28,75.79a5.06,5.06,0,0,1-10.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M199.39,147l.38-103.16a5.06,5.06,0,0,1,10.11,0l-.39,103.58a4.87,4.87,0,0,1-5.07,5A5.51,5.51,0,0,1,199.39,147Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M310.64,122.55l.19-52.63a5.06,5.06,0,0,1,10.11,0l-.2,52.21a4.87,4.87,0,0,1-5.07,5A4.78,4.78,0,0,1,310.64,122.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M110.72,101.17l0-11.37a5.05,5.05,0,0,1,10.1,0l0,11.37a4.86,4.86,0,0,1-5.07,5A5.43,5.43,0,0,1,110.72,101.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M44.16,109.34l.1-28.21a5.06,5.06,0,1,1,10.11,0l-.11,28.21a4.86,4.86,0,0,1-5.07,5A5.43,5.43,0,0,1,44.16,109.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M22.29,101.68l.05-13.9a4.87,4.87,0,0,1,5.08-5,4.86,4.86,0,0,1,5,5.07l-.05,13.89a4.87,4.87,0,0,1-5.07,5A4.87,4.87,0,0,1,22.29,101.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M0,94.86a4.87,4.87,0,0,1,5.07-5,4.87,4.87,0,0,1,5,5.07h0a4.87,4.87,0,0,1-5.08,5A4.87,4.87,0,0,1,0,94.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M377.25,99.65l0-6.74a5.06,5.06,0,0,1,10.11,0l0,6.74a5.05,5.05,0,0,1-10.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M333,104.11l.06-15.58a5.06,5.06,0,0,1,10.11,0l-.06,15.58a4.86,4.86,0,0,1-5.08,5A5.12,5.12,0,0,1,333,104.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M354.89,110.93,355,81.88a5.06,5.06,0,0,1,10.11,0L365,111a4.87,4.87,0,0,1-5.08,5A5.43,5.43,0,0,1,354.89,110.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M66.51,98.47l0-7.15a5.06,5.06,0,1,1,10.11,0l0,7.15a5.06,5.06,0,1,1-10.11,0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonorousLogo);
export default __webpack_public_path__ + "static/media/sonorous_logo.b9f6ce4e1e6142157ffca3f2594daabe.svg";
export { ForwardRef as ReactComponent };